import React, { useState } from 'react';

import { Select } from '../Select';
import { Icon } from '../IconExporter';
import { Container } from './styles';

type Target = {
  name: string;
  value: Item;
};

export type Item = {
  label: string;
  value: number | string;
  target?: Target;
}

export type FunnelSelectProps = {
  selectItems1: Item[];
  selectItems2: Item[];
  selectItems3: Item[];
  selectItems4: Item[];
  selectItems5: Item[];
  handleChangeCallback?: (item: Item) => void;
}

export const FunnelSelect = ({ selectItems1, selectItems2, selectItems3, selectItems4, selectItems5, handleChangeCallback }: FunnelSelectProps) => {

  const [selectedItem1, setSelectedItem1] = useState({} as Item);
  const [selectedItem2, setSelectedItem2] = useState({} as Item);
  const [selectedItem3, setSelectedItem3] = useState({} as Item);
  const [selectedItem4, setSelectedItem4] = useState({} as Item);
  const [selectedItem5, setSelectedItem5] = useState({} as Item);
  
  const handleChange = (name: string, value: Item, changeFunc: (value: Item) => void) => {
    changeFunc(value);

    handleChangeCallback && handleChangeCallback({
      ...value,
      target: {
        name,
        value,
      }
    });
  }

  return <Container>
    <div className="inputsContainer">
      <Select data={selectItems1} handleChangeCallback={(value) => handleChange("funnellvl1", value, setSelectedItem1)} />
      <Select data={selectItems2} handleChangeCallback={(value) => handleChange("funnellvl2", value, setSelectedItem2)} />
      <Select data={selectItems3} handleChangeCallback={(value) => handleChange("funnellvl3", value, setSelectedItem3)} />
      <Select data={selectItems4} handleChangeCallback={(value) => handleChange("funnellvl4", value, setSelectedItem4)} />
      <Select data={selectItems5} handleChangeCallback={(value) => handleChange("funnellvl5", value, setSelectedItem5)} />
    </div>
    <div className="funnelContainer">
      { selectItems1 && (
        <Icon name={(selectedItem1?.label !== '' && selectedItem1?.label !== 'Selecione') ? "funnellvl1" : "funnellvl1disabled"} size={190} sizeFollowOneAxis="width" />
      ) }
      
      { selectedItem2 && selectItems2 && (
        <Icon name={(selectedItem2?.label !== '' && selectedItem2?.label !== 'Selecione') ? "funnellvl2" : "funnellvl2disabled"} size={190} sizeFollowOneAxis="width" />
      ) }

      { selectedItem3 && selectItems3 && (
        <Icon name={(selectedItem3?.label !== '' && selectedItem3?.label !== 'Selecione') ? "funnellvl3" : "funnellvl3disabled"} size={190} sizeFollowOneAxis="width" />
      ) }

      { selectedItem4 && selectItems4  && (
        <Icon name={(selectedItem4?.label !== '' && selectedItem4?.label !== 'Selecione') ? "funnellvl4" : "funnellvl4disabled"} size={190} sizeFollowOneAxis="width" />
      ) }      

      {  selectedItem5 && selectItems5 && (
        <Icon name={(selectedItem5?.label !== '' && selectedItem5?.label !== 'Selecione') ? "funnellvl5" : "funnellvl5disabled"} size={190} sizeFollowOneAxis="width" />
      ) }
    </div>
  </Container>;
}